import script from "./SaemitalkDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaemitalkDetail.vue?vue&type=script&setup=true&lang=ts"

import "./SaemitalkDetail.vue?vue&type=style&index=0&id=26c9f0ee&lang=css"

const __exports__ = script;

export default __exports__